import { Box, Typography } from '@mui/material';

export const LayoutPlaceholder = ({
    title,
    subtitle,
    color = '#AFB1B3',
}: {
    title: string;
    subtitle: string;
    color?: string;
}) => {
    return (
        <Box
            sx={{
                p: 2,
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 4,
            }}
        >
            <Typography
                variant="h4"
                color={color}
                sx={{
                    fontWeight: 500,
                    textAlign: 'center',
                }}
            >
                {title}
            </Typography>
            {/* <Box
            sx={{
                width: 500,
                height: '56%',
                background: `center / 50% no-repeat url("https://lendicapublic.s3.amazonaws.com/assets/illustrations/placeholder.svg")`,
            }}
        /> */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <InvoiceIcon color={color} width={128} />
            </Box>
            <Typography
                variant="subtitle1"
                color={color}
                sx={{
                    fontWeight: 500,
                    textAlign: 'center',
                    maxWidth: 200,
                    textWrap: 'balance',
                }}
            >
                {subtitle}
            </Typography>
        </Box>
    );
};

const InvoiceIcon = ({ color, width }: { color: string; width: number }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={width}
        fill={color}
        viewBox="0 0 256 256"
    >
        <path d="M28,124a4,4,0,0,1,0-8H56a12,12,0,0,0,0-24H40a20,20,0,0,1,0-40h4V48a4,4,0,0,1,8,0v4H64a4,4,0,0,1,0,8H40a12,12,0,0,0,0,24H56a20,20,0,0,1,0,40H52v4a4,4,0,0,1-8,0v-4ZM228,56V192a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V152a4,4,0,0,1,8,0v40a4,4,0,0,0,4,4H164V156H80a4,4,0,0,1,0-8h84V108H104a4,4,0,0,1,0-8H220V60H96a4,4,0,0,1,0-8H224A4,4,0,0,1,228,56Zm-56,92h48V108H172Zm48,44V156H172v40h44A4,4,0,0,0,220,192Z"></path>
    </svg>
);
